
import { css } from 'lit';
export default css`
:host{
  display:block;
}

.pc-chip-card--list{
  display:flex;
  flex-wrap:wrap;
  gap:var(--spacing-6);
}

@media (min-width: 992px){

.pc-chip-card--list{
    gap:var(--spacing-4)
}
  }

:host([stacked]) .pc-chip-card{
    border-bottom:var(--neutral-light) solid 2px;
    padding-bottom:var(--spacing-8);
  }

@media (min-width: 992px){

:host([stacked]) .pc-chip-card{
      padding-bottom:var(--spacing-16)
  }
    }
`;